import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import {
    QrcodeSuccessCallback,
    QrcodeErrorCallback,
    Html5QrcodeSupportedFormats,
    Html5QrcodeScanType,
    Html5QrcodeScanner,
    Html5Qrcode,
} from 'html5-qrcode';
import { QrDimensions, QrDimensionFunction } from 'html5-qrcode/esm/core';
import { AngularHtmlQrcodeService } from './html-qrcode-scanner.service';

export interface AngularHTML5QRCodeSupportedScanTypes {
    camera: Html5QrcodeScanType[] | undefined;
    file: Html5QrcodeScanType[] | undefined;
    both: Html5QrcodeScanType[] | undefined;
}

@Component({
    selector: 'html-qrcode-scanner',
    imports: [],
    templateUrl: './html-qrcode-scanner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './html-qrcode-scanner.component.scss'
})
export class HtmlQrcodeScanner {
    @Output() onSuccess = new EventEmitter<QrcodeSuccessCallback>();
    @Output() onError = new EventEmitter<QrcodeErrorCallback>();
    @Input() types: Html5QrcodeSupportedFormats[] = [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.AZTEC,
        Html5QrcodeSupportedFormats.CODABAR,
        Html5QrcodeSupportedFormats.CODE_39,
        Html5QrcodeSupportedFormats.CODE_93,
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.DATA_MATRIX,
        Html5QrcodeSupportedFormats.MAXICODE,
        Html5QrcodeSupportedFormats.ITF,
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.PDF_417,
        Html5QrcodeSupportedFormats.RSS_14,
        // Html5QrcodeSupportedFormats.RSS_EXPANDED,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
    ];
    @Input() fps: number = 10;
    @Input() selectorID: string = 'reader';
    @Input() rememberLastUsedCamera: boolean = true;
    @Input() aspectRatio?: number = 1.333334;

    @Input() disableFlip: boolean = false;
    @Input() supportCameraOrFile: 'camera' | 'file' | 'both' = 'both';
    private supportedTypes: AngularHTML5QRCodeSupportedScanTypes = {
        camera: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
        file: [Html5QrcodeScanType.SCAN_TYPE_FILE],
        both: [
            Html5QrcodeScanType.SCAN_TYPE_CAMERA,
            Html5QrcodeScanType.SCAN_TYPE_FILE,
        ],
    };
    @Input() qrbox: QrDimensions | QrDimensionFunction = {
        width: 300,
        height: 300,
    };

    html: Html5QrcodeScanner = null;

    html5QrCode: Html5Qrcode = null;

    isLoading = false;

    constructor(public angularHtmlQrcodeService: AngularHtmlQrcodeService) {}

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.isLoading = true;
            // this.onReaderLoad();
            this.getCamerasPermission();
        }, 80);
        //Called after ngOnInit when the component's or directive's content has been initialized.
        //Add 'implements AfterContentInit' to the class.
    }

    onReaderLoad() {
        console.log('dad');
        this.html = this.angularHtmlQrcodeService.html5QrcodeScanner(
            this.selectorID,
            {
                formatsToSupport: this.types,
                fps: this.fps,
                rememberLastUsedCamera: this.rememberLastUsedCamera,
                disableFlip: this.disableFlip,
                supportedScanTypes:
                    this.supportedTypes[this.supportCameraOrFile],
                aspectRatio: this.aspectRatio,
                qrbox: this.qrbox,
            },
            true
        );
        this.html.render(
            (value: any) => {
                this.onSuccess.emit(value);
                this.html.clear();
            },
            (err: any) => {
                this.onError.emit(err);
            }
        );
    }

    getCamerasPermission() {
        // This method will trigger user permissions
        Html5Qrcode.getCameras()
            .then((devices) => {
                /**
                 * devices would be an array of objects of type:
                 * { id: "id", label: "label" }
                 */
                if (devices && devices.length) {
                    var cameraId = devices[0].id;
                    this.isLoading = false;

                    // .. use this to start scanning.
                    this.startScanning(cameraId);
                }
            })
            .catch((err) => {
                this.isLoading = false;

                // handle err
                this.onError.emit(err);
            });
    }

    startScanning(cameraId: string) {
        this.html5QrCode = new Html5Qrcode(this.selectorID);
        this.html5QrCode
            .start(
                cameraId,
                {
                    fps: 10, // Optional, frame per seconds for qr code scanning
                    qrbox: { width: 250, height: 250 }, // Optional, if you want bounded box UI
                },
                (decodedText, decodedResult) => {
                    // do something when code is read
                    this.onSuccess.emit(decodedText as any);
                    this.html5QrCode.stop();
                },
                (errorMessage) => {
                    // parse error, ignore it.
                }
            )
            .catch((err) => {
                // html5QrCode.stop();
                // Start failed, handle it.
                this.onError.emit(err);
            });
    }
}
